import * as M from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import type { IDeviceFilterForm } from '../../../../../../shared/types/device';
import { InfoField } from '../../../../../ui/infoField/InfoField';

interface IPropsDeviceFilterSection {
  filterForm: IDeviceFilterForm;
  onChangeFilterForm: (nextFilter: Partial<IDeviceFilterForm>) => void;
  onSearch: () => void;
  onReset: () => void;
}

const serviceOptions = [
  { value: 'progix', label: 'PROGIX' },
  { value: 'scautr', label: 'SCAUTR' },
  { value: 'MFM', label: 'MFM' },
];

export default function DeviceFilterSection(props: IPropsDeviceFilterSection) {
  const { filterForm, onChangeFilterForm, onSearch, onReset } = props;

  const onChangeService = (value: string, checked: boolean) => {
    if (!checked) {
      onChangeFilterForm({
        services: filterForm.services.filter((service) => service !== value),
      });
      return;
    }

    const nextServices = [...filterForm.services, value];

    onChangeFilterForm({
      services: nextServices,
    });
  };

  return (
    <M.Box
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        borderLeft: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <M.SimpleGrid cols={2} spacing={0} verticalSpacing={0} style={{ gridTemplateColumns: '180px minmax(0, 1fr)' }}>
        <InfoField label="가입 서비스" labelAlign="left" contentAlign="left">
          <M.Flex gap="lg" wrap="wrap">
            <M.Checkbox
              label="전체"
              size="sm"
              checked={filterForm.services.length === 0}
              onChange={() => onChangeFilterForm({ services: [] })}
            />
            {serviceOptions.map((option) => (
              <M.Checkbox
                key={option.value}
                label={option.label}
                size="sm"
                checked={filterForm.services.includes(option.value)}
                onChange={(event) => onChangeService(option.value, event.currentTarget.checked)}
              />
            ))}
          </M.Flex>
        </InfoField>
        <InfoField label="서비스 만료일자" labelAlign="left" contentAlign="left">
          <M.Flex gap="xs" align="center" wrap="wrap">
            <DatePickerInput
              leftSection={<IconCalendar size={14} />}
              placeholder="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              w={210}
              value={filterForm.startDate}
              onChange={(date) => onChangeFilterForm({ startDate: date })}
            />
            <M.Text c="gray.7">-</M.Text>
            <DatePickerInput
              leftSection={<IconCalendar size={14} />}
              placeholder="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              w={210}
              value={filterForm.endDate}
              onChange={(date) => onChangeFilterForm({ endDate: date })}
            />
          </M.Flex>
        </InfoField>
        <InfoField label="상세 검색" labelAlign="left" contentAlign="left">
          <M.Flex gap="sm" align="center" wrap="wrap" w="100%">
            <M.TextInput
              w={400}
              placeholder="거래처명/단말기 일련번호/MAC번호로 검색"
              value={filterForm.keyword}
              onChange={(event) => onChangeFilterForm({ keyword: event.currentTarget.value })}
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                if (event.key === 'Enter') {
                  onSearch();
                }
              }}
            />
            <M.Button variant="filled" color="primary.5" onClick={onSearch}>
              조회
            </M.Button>
            <M.Button variant="default" onClick={onReset}>
              초기화
            </M.Button>
          </M.Flex>
        </InfoField>
      </M.SimpleGrid>
    </M.Box>
  );
}
